module.exports = __webpack_public_path__ + "static/DHCM2-45d12b0eb6a1461299462caea18a91e3.png";